export var SplitType;
(function (SplitType) {
    SplitType["Equal"] = "EQUAL";
    SplitType["Custom"] = "CUSTOM";
})(SplitType || (SplitType = {}));
//# sourceMappingURL=split-type.enum.js.map